export default {
  getShowDialog(state) {
    return state.showModalPatchNotes;
  },
  getDataPatchNotes(state) {
    return state.patchNotes;
  },
};
